import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import Routes from "./App"
import reportWebVitals from "./reportWebVitals"
import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { ChakraProvider } from "@chakra-ui/react"
import { GoogleOAuthProvider } from "@react-oauth/google"
import CustomTheme from "./components/CustomTheme"
import env from "./lib/env"

if (process.env.NODE_ENV !== "test") {
  const logo = [
    "                    ≠==÷×××≠=××÷×          ",
    "                 ≠≠ ≠=÷÷××× =×  ≠=÷××=÷   ",
    "              =≠≠≠≠≠==÷××××≠=÷××==÷×× =×× ",
    "           ==≠≠≠≠≠≠≠=÷÷×××× =×××=÷××× ÷×× ",
    "        ====≠≠≠≠≠≠≠≠≠≠≠≠≠ ≠≠===÷÷×××× ÷ × ",
    "     ÷÷÷===≠≠≠≠≠≠≠≠≠≠≠≠≠≠ ≠≠==÷÷÷×××××≠÷××",
    "  ××÷÷÷÷====≠≠≠≠≠≠≠≠≠≠≠≠≠ ≠≠==÷÷××××××=÷××",
    "  ×××÷÷÷÷====≠≠≠≠≠≠≠≠≠≠≠≠≠≠ ≠===÷÷××××××≠=",
    "  ×××÷÷÷÷÷===≠≠≠≠≠≠≠≠≠≠≠≠≠≠ ≠==÷÷×××××××≠=",
    "  ×××÷÷÷÷÷====≠≠≠≠≠≠≠≠≠≠≠≠≠ ===÷÷×××××××=÷",
    "  ×××÷÷÷÷====≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠            =÷",
    "  ×××÷÷÷÷÷====≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠==÷",
    "  ×××÷÷÷÷÷===≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠=≠≠==÷",
    "  ×××÷÷÷÷=====≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠====≠==÷÷",
    "  ×××÷÷÷÷÷====≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠==========÷÷",
    "  ×××÷÷÷÷÷======≠≠≠≠≠≠≠≠≠≠≠=======÷÷÷==÷÷×",
    "  ×××÷÷÷÷÷÷÷=======≠≠≠≠≠======÷÷÷÷÷÷÷÷××  ",
    "  ××××÷÷÷÷÷÷÷÷÷============÷÷÷÷÷÷÷÷÷×××××  ",
    "  ×××××××÷÷÷÷÷÷÷÷÷======÷÷÷÷÷÷÷÷÷××××××××  ",
    "  ××××××××××÷÷÷÷÷÷÷÷÷÷÷÷÷÷÷÷÷÷××××××××××   ",
    "    ××××××××××××÷÷÷÷÷÷÷÷÷÷×××××××××××××    ",
    "      ×××××××××××××÷÷÷÷×××××××××××××       ",
    "         ××××××××××××××××××××××××          ",
    "             ××××××××××××××××              ",
    "                ××××××××××                 ",
    "                   ×××××                   ",
  ].join("\n")
  console.log(
    `%c${logo}`,
    [
      "color: #7059BD",
      "font-family: monospace",
      "font-size: 12px",
      "line-height: 1",
    ].join(";"),
  )
  console.log(
    "%c BLIND INSIGHT  |  A secure substrate for sensitive data.",
    [
      "color: #E3E0EF",
      "background: #3E2688",
      "font-size: 11px",
      "font-weight: 700",
      "padding: 4px 16px",
      "border-radius: 3px",
      "letter-spacing: 3px",
      "font-family: monospace",
    ].join(";"),
  )
}

const router = createBrowserRouter(Routes)
const root = ReactDOM.createRoot(document.getElementById("root"))
const googleClientId =
  process.env.BLINDINSIGHT_GOOGLE_CLIENT_ID || env.BLINDINSIGHT_GOOGLE_CLIENT_ID

root.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <ChakraProvider theme={CustomTheme}>
      <RouterProvider router={router} />
    </ChakraProvider>
  </GoogleOAuthProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
